/* istanbul ignore file */
import { actions, sleep } from '@americanexpress/amex-connect-core';

export const mockSendPartnerToken = async (dispatch) => {
  await sleep(1000);
  dispatch(actions.updateCorrelationId('mockCorrelationId'));
};

export const mockValidateUrl = async (dispatch) => {
  await sleep(1000);
  dispatch(actions.updateCorrelationId('mockProvisionId'));
  dispatch(actions.updateProvisionId('mockProvisionId'));
};
